/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import RevenueFromSubMonthBarChart from './RevenueFromSubMonthBarChart';
import { sortByOptions } from '../../helper';

const MonthlySubsSalesCategoryWise = ({ dir, subscribed, categorisedBasedOn,
    unsubscribed, monthsBetweenDates, title, viewReportButton, currentlyShow }) => {

    const categorisedBasedOnRef = useRef({ categorisedBasedOn });

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])

    useEffect(() => {
        if (categorisedBasedOnRef?.current?.categorisedBasedOn !== categorisedBasedOn) {
            setSelectedOptions([])
        }
    }, [categorisedBasedOn])

    const changeFilter = (value) => {
        setSelectedOptions(value)
    };

    const subscribedSalesByCategory = {};
    const unsubscribedSalesByCategory = {}

    subscribed.forEach((item) => {

        if (item && subscribedSalesByCategory[item?.[categorisedBasedOn]]) {
            subscribedSalesByCategory[item?.[categorisedBasedOn]]?.push(item)
        } else if (item) {
            if (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null') {
                if (subscribedSalesByCategory?.['N/A']) {
                    subscribedSalesByCategory['N/A']?.push(item)
                } else {
                    subscribedSalesByCategory['N/A'] = item
                }
            } else {
                subscribedSalesByCategory[item?.[categorisedBasedOn]] = [item]
            }
        }
    });

    unsubscribed.forEach((item) => {
        if (item && unsubscribedSalesByCategory[item?.[categorisedBasedOn]]) {
            unsubscribedSalesByCategory[item?.[categorisedBasedOn]]?.push(item)
        } else if (item) {
            if (!item?.[categorisedBasedOn] || item?.[categorisedBasedOn] === 'null') {
                if (unsubscribedSalesByCategory?.['N/A']) {
                    unsubscribedSalesByCategory['N/A']?.push(item)
                } else {
                    unsubscribedSalesByCategory['N/A'] = item
                }
            } else {
                unsubscribedSalesByCategory[item?.[categorisedBasedOn]] = [item]
            }
        }
    });

    const currentMonthCatCount = Object.keys(subscribedSalesByCategory).length;
    const prevMonthCatCount = Object.keys(unsubscribedSalesByCategory).length;
    const currentMonthCat = Object.keys(subscribedSalesByCategory);
    const prevMonthCat = Object.keys(unsubscribedSalesByCategory);

    const max = currentMonthCatCount > prevMonthCatCount ? currentMonthCat : prevMonthCat;

    let dataToPlot = [];

    const options = []

    const reduceCallback = (acc, item) => {
        if (item?.salesMonth && acc[item.salesMonth]) {
            acc[item.salesMonth]?.push(item)
        } else if (item.salesMonth) {
            acc[item.salesMonth] = [item]
        }
        return acc;
    }

    for (let i = 0; i < max.length; i += 1) {
        const cat = max[i];
        const unsubscribedByCat = unsubscribedSalesByCategory?.[cat] ?? [];
        const subscribedByCat = subscribedSalesByCategory?.[cat] ?? [];

        let unsubscribedByCatMax = 0;
        let subscribedByCatMax = 0;

        unsubscribedByCat?.forEach((item) => {
            unsubscribedByCatMax += Number(item.amount)
            subscribedByCatMax += Number(item.amount)
        }
        );

        const unsubscribedByCatMonthDayWise = unsubscribedByCat?.reduce(reduceCallback, {})
        const subscribedByCatMonthDayWise = subscribedByCat?.reduce(reduceCallback, {});

        options.push({
            value: cat, label: cat
        })

        dataToPlot.push({
            title: cat,
            subscribedMonthWise: subscribedByCatMonthDayWise,
            unsubscribedMonthWise: unsubscribedByCatMonthDayWise,
            currentYearMonthMax: unsubscribedByCatMax + subscribedByCatMax

        })
    }

    if (selectedOptions?.length) {
        const selected = selectedOptions?.reduce((acc, item) => {
            acc[item?.value] = item.value
            return acc
        }, {})
        dataToPlot = dataToPlot.filter(item => selected[item.title])
    }

    const sortBy = sortBySelected?.value;

    if (sortBy === 'title') {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }

    return (
        <Col xs="12">
            <CardBody>
                <Card className="pb-3 revenue-from-subs-sales">
                    <div className="card__title row ">
                        <h5 className="bold-text col-md-4">{title}</h5>
                        <div className="form__form-group mb-0 col-md-6">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-6" id='dvTable'>
                                    <span className="form__form-group-label font-weight-bold">
                                        {`Select ${currentlyShow?.value}`}</span>
                                    <div className="form__form-group-field">
                                        <Select
                                            value={selectedOptions}
                                            options={options}
                                            clearable={false}
                                            placeholder={`Select ${currentlyShow?.value}`}
                                            className="select_filter"
                                            onChange={changeFilter}
                                            classNamePrefix="react-select"
                                            isMulti
                                        />
                                    </div>
                                </div>
                                <div className="col-6" id='dvChartFilter'>
                                    <span className="form__form-group-label font-weight-bold">Sort By</span>
                                    <div className="form__form-group-field">
                                        <Select
                                            value={sortBySelected}
                                            options={sortByOptions}
                                            clearable={false}
                                            placeholder="Sort By"
                                            className="select_filter"
                                            onChange={setSortBySelected}
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <CardBody>
                        
                        {viewReportButton?.()}
                        {dataToPlot?.length ? dataToPlot?.map((category, index) => (
                            <Row key={category.title}>
                                <Col sm={4} md={2}><CardText>{category.title}</CardText></Col>
                                <Col sm={8} md={10}>
                                    <RevenueFromSubMonthBarChart
                                        subscribedMonthWise={category.subscribedMonthWise}
                                        unsubscribedMonthWise={category.unsubscribedMonthWise}
                                        height={275}
                                        showTitle={false}
                                        dir={dir}
                                        index={index}
                                        monthsBetweenDates={monthsBetweenDates}
                                    />
                                </Col>
                            </Row>
                        )) : 'No data to display'}
                    </CardBody>

                </Card>
            </CardBody>
        </Col>

    )
}

MonthlySubsSalesCategoryWise.propTypes = {
    dir: PropTypes.string.isRequired,
    unsubscribed: PropTypes.array.isRequired,
    subscribed: PropTypes.array.isRequired,
    monthsBetweenDates: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    categorisedBasedOn: PropTypes.string,
    currentlyShow: PropTypes.object.isRequired,
};

MonthlySubsSalesCategoryWise.defaultProps = {
    title: 'Month Comparison By Category',
    categorisedBasedOn: 'productCategory'
}

export default MonthlySubsSalesCategoryWise;
